import { colors } from '@/styles/GlobalStyle';
import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  max-width: 1360px;

  display: flex;
  justify-content: center;

  @media (max-width: 1440px) {
    padding: 0 40px;
  }

  @media (max-width: 499px) {
    padding: 0 16px;
  }
`;

export const Section = styled.section`
  width: 100%;
  background: ${colors.orange400};

  display: flex;
  justify-content: space-between;
  column-gap: 30px;
  align-items: center;

  overflow: hidden;
  border-radius: 10px;

  .mobile {
    display: none;
  }

  svg * {
    width: 100%;
    height: 100%;
  }

  img {
    object-fit: cover;
    object-position: -105px 57%;
    width: 1010px !important;

    max-width: initial !important;
  }

  div:not(.text) {
    max-height: 220px !important;
    max-width: 640px !important;
  }

  .text {
    padding: 20px 0;
    max-width: 362px;

    h2 {
      font-size: 42px;
      font-style: italic;
      font-weight: 400;
      font-family: 'Exo 2';
      line-height: 52px;
      color: white;
      font-weight: 500;
    }

    a {
      color: white;
      font-family: 'Sora';
      font-weight: 400;
      line-height: 24px;
      font-size: 16px;

      margin-top: 21px;

      display: inline-block;

      :hover {
        text-decoration: underline;
      }

      svg {
        vertical-align: middle;
        height: 20px;
      }
    }
  }

  > .desktop {
    margin-right: -24px;
  }

  @media (max-width: 1200px) {
    img {
      object-position: -150px 57%;
    }
  }

  @media (max-width: 1100px) {
    img {
      object-position: -175px 57%;
    }
  }

  @media (max-width: 1075px) {
    flex-direction: column;
    max-height: 600px;
    justify-content: flex-start;

    .desktop {
      display: none;
    }

    .mobile {
      display: block;
    }

    div:not(.text) {
      max-height: fit-content !important;
      max-width: 100% !important;
    }

    img {
      width: 1100px !important;
      object-position: 0px;
    }

    .mobile-container {
      display: flex;
      justify-content: space-between;

      padding: 38px 0;

      .text {
        margin: 0 auto;
        padding: 0;
      }

      > svg {
        margin-right: -24px;
      }

      width: 100%;
    }
  }

  @media (max-width: 1040px) {
    img {
      object-position: -50px;
    }
  }

  @media (max-width: 810px) {
    img {
      object-position: -150px;
    }
  }

  @media (max-width: 725px) {
    img {
      width: 800px !important;
      object-position: -50px;
    }
  }

  @media (max-width: 650px) {
    img {
      object-position: -100px;
    }

    .mobile-container {
      margin: 0;

      padding: 20px 0;
      gap: 30px;

      .text {
        margin: 0;
        margin-left: 30px;

        a {
          max-width: 200px;
        }
      }

      justify-content: space-around;
    }
  }
  @media (max-width: 575px) {
    max-height: 480px;
    img {
      object-position: -145px -150px;
      width: 400px;
    }

    .mobile {
      margin-left: -50px;
    }
  }

  @media (max-width: 499px) {
    img {
      object-position: 50%;
      width: 125% !important;
    }

    .mobile-container {
      align-items: center;
      gap: 10px;
    }

    .mobile {
      height: 120px;
      margin-left: -70px;
    }
  }

  @media (max-width: 420px) {
    .mobile {
      height: 80px;
      margin-left: -30px;
    }
  }
`;
